import { useState, useEffect, useRef } from "react";
import { australianLocations } from "../data/locations";

export function useLocationModal(announceToScreenReader) {
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [locationSearchQuery, setLocationSearchQuery] = useState("");
  const [filteredLocations, setFilteredLocations] = useState([]);
  const searchInputRef = useRef(null);

  const [locationSelectCallback, setLocationSelectCallback] = useState(null);
  const [isLocationMultiSelect, setIsLocationMultiSelect] = useState(false);
  const [selectedLocationsInModal, setSelectedLocationsInModal] = useState([]);

  useEffect(() => {
    if (locationSearchQuery.length > 1) {
      const filtered = australianLocations
        .filter((loc) =>
          loc.toLowerCase().includes(locationSearchQuery.toLowerCase()),
        )
        .slice(0, 8);
      setFilteredLocations(filtered);
    } else {
      setFilteredLocations([]);
    }
  }, [locationSearchQuery]);

  const handleLocationSelect = (selectedLocation) => {
    if (isLocationMultiSelect) {
      handleModalLocationSelect(selectedLocation);
    } else {
      if (locationSelectCallback) {
        locationSelectCallback(selectedLocation);
      }
      setShowLocationModal(false);
      setLocationSearchQuery("");
      setLocationSelectCallback(null);
    }
  };

  const pickLocationFromSearch = (location) => {
    if (!location) return;
    if (isLocationMultiSelect) {
      setSelectedLocationsInModal((prev) =>
        prev.includes(location) ? prev : [...prev, location],
      );
      setLocationSearchQuery("");
      announceToScreenReader?.(`Added ${location}`);
    } else {
      handleLocationSelect(location);
    }
  };

  const pickTopSearchResult = () => {
    const next = filteredLocations.find(
      (loc) => !selectedLocationsInModal.includes(loc),
    );
    if (next) pickLocationFromSearch(next);
  };

  const openLocationModal = (callback, multiSelect = false) => {
    setLocationSelectCallback(() => callback);
    setIsLocationMultiSelect(multiSelect);
    setSelectedLocationsInModal([]);
    setShowLocationModal(true);
    announceToScreenReader("Opening location selection modal");
  };

  const handleModalLocationSelect = (location) => {
    setSelectedLocationsInModal((prev) =>
      prev.includes(location)
        ? prev.filter((loc) => loc !== location)
        : [...prev, location],
    );
  };

  const closeLocationModal = () => {
    setShowLocationModal(false);
    setLocationSearchQuery("");
    setLocationSelectCallback(null);
    setIsLocationMultiSelect(false);
    setSelectedLocationsInModal([]);
  };

  return {
    showLocationModal,
    setShowLocationModal,
    locationSearchQuery,
    setLocationSearchQuery,
    filteredLocations,
    searchInputRef,
    selectedLocationsInModal,
    setSelectedLocationsInModal,
    isLocationMultiSelect,
    locationSelectCallback,
    handleLocationSelect,
    pickLocationFromSearch,
    pickTopSearchResult,
    openLocationModal,
    handleModalLocationSelect,
    closeLocationModal,
  };
}
